import type { OverlayBadgeDesignTokens } from '@primeuix/themes/aura/overlaybadge';

export default {
  root: {
    outline: {
      width: '2px',
      color: '{content.background}',
    },
  },
} satisfies OverlayBadgeDesignTokens;
